import { cx } from "classix"
import cssModule from "~/shared/ui/layouts/main/index.module.scss"
import { IconButton } from "~/shared/ui"

export function MenuButton(props: { hideCurtain: boolean, closeMenuButton: any, onClick: (() => void) | undefined }) {
	return <div className={cx(cssModule.menuButton, !props.hideCurtain && cssModule.ifShowCurtain)}>
		<IconButton
			size="2rem"
			iconSize="2rem"
			style={{
				verticalAlign: "-0.35em",
				...(props.hideCurtain
					? {}
					: props.closeMenuButton?.style ?? {})
			}}
			className={
				props.hideCurtain
					? undefined
					: props.closeMenuButton?.className
			}
			onClick={props.onClick}
			transparent
			colorStyle={
				props.hideCurtain
					? "primary"
					: (props.closeMenuButton
						?.colorStyle ?? "light")
			}
			borderless
			icon={props.hideCurtain ? "menu" : "close"}
		/>
	</div>
}